<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="true"
    transition="scale-transition"
    offset-y
    min-width="auto"
    color="primaryText"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="localeDate"
        label="Date"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        :disabled="disabled"
        v-on="on"
        :clearable="clearable"
        @click:clear.prevent="$emit('change', null)"
        hide-details
      />
    </template>
    <v-date-picker
      :value="date"
      @input="$emit('change', $event)"
      :max="max"
      no-title
      scrollable
      :disabled="disabled"
      color="primaryText"
      background-color="background"
    >
      <v-spacer />
      <v-btn text color="primaryText" @click="menu = false"> Cancel </v-btn>
      <v-btn text color="primaryText" @click="menu = false"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "menu-date-picker.vue",
  props: [
    "date", // format 'yyyy-mm-dd'
    "disabled",
    "max",
    "clearable",
  ],
  emits: ["change"],
  model: {
    prop: "date",
    event: "change",
  },

  data: function () {
    return {
      menu: false,
      mutableDate: undefined,
    };
  },

  computed: {
    localeDate() {
      if (!this.date) return null;
      return new Date(this.date).toLocaleDateString(undefined, {
        timeZone: "UTC",
      });
    },
  },

  mounted: function () {
    this.mutableDate = this.date;
  },
};
</script>

<style scoped></style>
